import ApiClient from 'api-client/ApiClient'
import ActionsSet from 'core/actions/ActionsSet'
import ListAction from 'core/actions/ListAction'
import DataKeys, { entityNamesByKey } from 'k8s/DataKeys'
import Bugsnag from 'utils/bugsnag'

const { kubernetes } = ApiClient.getInstance()

export const kaapiOpenStackServerActions = ActionsSet.make<DataKeys.KaapiOpenStackServers>({
  uniqueIdentifier: 'metadata.uid',
  entityName: entityNamesByKey[DataKeys.KaapiOpenStackServers],
  cacheKey: DataKeys.KaapiOpenStackServers,
})

export const listKaapiOpenStackServers = kaapiOpenStackServerActions.add(
  new ListAction<DataKeys.KaapiOpenStackServers, { namespace: string }>(async ({ namespace }) => {
    Bugsnag.leaveBreadcrumb('Attempting to list Kaapi OpenStackServers', { namespace })
    return kubernetes.getAllCustomResources(DataKeys.KaapiOpenStackServers)
  }),
)
